import { Select } from "antd";
import React from "react";
import Close from "../assets/cancel.svg";
import "./grid-styles.css";

const AddTable = (props) => {
  const checkTD = (ele, i) => ele.key === "ThreadDepth" && parseFloat(props.values?.[i]?.["ThreadDepth"]) > parseFloat(props.selectedTD[props.values?.[i]?.["Matnr"]])
  return (
    <div className="addnew-table">
      <h3 style={{ marginBottom: "1rem" }}>{props.label}</h3>
      <div>
        <div className="table">
          {/* <div className="t-wrap"> */}
          {/* <div className="thead">
            <div className="tr">
              {props.columns?.map((ele) => {
                return (
                  <div className={`td ${ele.className || ""}`} style={{ width: ele.width + "rem" }}>
                    {ele.header}
                  </div>
                );
              })}
              <div className="td" style={{ width: 3 + "rem" }}>
              </div>
            </div>
          </div> */}
          <div className={`tbody`}>
            {props.values?.map((item, i) => (
              <div className={`tr grid ${item?.Clstatus?.toLowerCase() === "rejected" ? "rejected" : ""}`}>
                {props.columns.map((ele) => {
                  return (
                    <div
                      className={`td ${ele.className ? ele.className : ""}`}
                      style={{ width: ele.width + "rem" }}
                    >
                      <div className="header-name">
                        {ele.header}
                      </div>
                      <div>
                        {ele.render ? ele.render(i) : ele.type === "select" ?
                          <div className="d-flex">
                            <Select className="w100" name={ele.altKey} options={ele.options} value={ele.key === "claimReason" && item[ele.key] !== "Others" ? item[ele.altKey] : item[ele.key]} disabled={ele.disabled} onChange={(value) => {
                              if (ele.key === "claimReason") {
                                if (value !== "Others") {
                                  props.onChange(value, i, ele.altKey)
                                  props.onChange("", i, ele.key)
                                } else {
                                  props.onChange(value, i, ele.key)
                                  props.onChange("", i, ele.altKey)
                                }
                              } else {
                                props.onChange(value, i, ele.key);
                              }
                            }} />
                            {ele.key === "claimReason" && item[ele.key] === "Others" && <input className="mlHalf" name={ele.altKey} value={item[ele.altKey]} disabled={ele.disabled} onChange={(e) => {
                              props.onChange(e.target.value.trimStart(), i, ele.altKey)
                            }} />}
                          </div>
                          : ele.type === "number" ? <input name={ele.key} disabled={ele.disabled} value={ele.show ? ele.show(item[ele.key]) : item[ele.key]} onChange={(e) => {
                            if (Number.isNaN(Number(e.target.value))) {
                              return;
                            }
                            if (e.target.value !== "" && Number(e.target.value) === 0 && (ele.key === "Kwmeng" || ele.key === "ThreadDepth")) {
                              return;
                            }
                            if (ele.key === "Kwmeng") {
                              props.onChange(e.target.value ? parseInt(e.target.value) : e.target.value, i, ele.key)
                            } else {
                              props.onChange(e.target.value, i, ele.key)
                            }
                          }} /> :
                            <input name={ele.key} value={ele.show ? ele.show(item[ele.key]) : item[ele.key]} disabled={ele.disabled} onChange={(e) => {
                              props.onChange(e.target.value.trimStart(), i, ele.key)
                            }} />}
                      </div>
                      {checkTD(ele, i) && <div className="error-msg">
                        Thread depth cannot be greater than selected material thread depth ({props.selectedTD[props.values?.[i]?.["Matnr"]]}mm)
                      </div>}
                      {ele.key === "claimReason" ? props.touched?.[i]?.[ele.altKey] && props.errors?.[i]?.[ele.altKey] && <div className="error-msg">
                        {props.errors?.[i]?.[ele.altKey]}
                      </div> : props.touched?.[i]?.[ele.key] && props.errors?.[i]?.[ele.key] && <div className="error-msg">
                        {checkTD(ele, i) && ele.key === "ThreadDepth" ? "" : props.errors?.[i]?.[ele.key]}
                      </div>}
                      {props.touched?.[i]?.[ele.key] && props.picError && ele.key === "Picture" && <div className="error-msg"> Picture is Required</div>}
                    </div>
                  );
                })}
                {!props.isEdit &&
                  <div
                    className={`cursor td-close`}
                    onClick={() => {
                      props.removeItem(i)
                    }}
                  >
                    <img src={Close} alt="close" width={20} />
                  </div>
                }
              </div>
            ))}
          </div>
        </div>
      </div>
      {!props.isEdit &&
        <div className="addNew cursor" onClick={props.addRow}>
          <span>+ Add New</span>
        </div>}
    </div>
  );
};

export default AddTable;
